export const passwordRegex = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).*$"
export const passwordOrEmptyRegex = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).*$|^$"
